import React, { useContext, useEffect, useState } from 'react';
import Card from '../layout/Card';
import { UserCheck } from "lucide-react";
import Loader from './Loader';
import AppContext from '../Context/AppContext';
import axios from 'axios';


import icEmpire from "../assets/logos/logo-empire-str.png";
import icAnime from "../assets/logos/logo-empire-anime.png";
import StatProjectInfo from './StatProjectInfo';


/** projects
 * label 
 * project
 * views
 * status : no , up , down
*/


const StatSubscriber = ({ open, projectLabel }) => {

    const { mapUrl } = useContext(AppContext)
    const mapProject = {
        "empirestreaming": {
            label: "Empire Streaming",
            url: "get_user_create_empire",
            icone: icEmpire,
        },
        "empireanime": {
            label: "Empire Anime",
            url: "get_user_create_empire_anime",
            icone: icAnime,
        }
    }
    const urlMatch = mapProject[projectLabel].url;

    const [statProject, setStatProject] = useState([]);
    const [error, setError] = useState("");
    const initStatProject = async () => {

        if (mapUrl[urlMatch]) {
            try {
                const currentDate = new Date();
                const formattedDate = currentDate.toISOString().split('T')[0];
                const response = await axios.get(mapUrl[urlMatch] + "&date=" + formattedDate);
                if (response?.data) {
                    setStatProject(response.data);
                }
            } catch (error) {
                setError("Erreur lors de la récupération des statistiques")
                console.error("Erreur lors de la récupération des statistiques :", error);
            }
        }
    };
    const openTabCenter = (name) => {

        switch (name) {
            case "_empStrvideo":
                return open(<StatProjectInfo label={"Empire Streaming"} targetUrl={"occurence_empire"} />)
                break;
            case "_empAnivideo":
                return open(<StatProjectInfo label={"Empire Anime"} targetUrl={"occurence_empire_anime"} />)
                break;
            default:
                break;
        }
        return null
    }


    useEffect(() => {
        initStatProject()
    }, [])

    if (error) {
        return <div className='py2'>
            <p className='corange fs16'>{error}</p>
        </div>
    }

    if (!statProject) {
        return <div className='py2'>
            <Loader />
        </div>
    }


    return (
        <div className='df fdc mt1'>
            {statProject &&
                <div className='mb1' >
                    <Card>
                        <button onClick={() => { }} className='df aic'>
                            <div className='mr3 px1 py1 df aic bcb jc' style={{ borderRadius: "50%" }}  >
                                <img style={{ height: "30px", width: "30px", objectFit: "contain" }} src={mapProject[projectLabel].icone} alt="logo" srcset="" />
                            </div>
                            <div>
                            <p className='fl cw fs12'>{mapProject[projectLabel].label}</p>
                                <div className='df aic'>
                                    <div className='mr1'>
                                        <UserCheck size={15} color='#fff' />
                                    </div>
                                    <p className='fs28 cw fb'>{statProject.total}</p>
                                </div>
                            </div>
                        </button>
                    </Card>
                </div>
            }
        </div>
    );
};

export default StatSubscriber;